let publicPath = process.env.VUE_APP_PUBLIC_PATH;

if (/\/$/.test(publicPath)) {
    publicPath = publicPath.slice(0, publicPath.length - 1);
}

export default function(p) {
    return publicPath + p;
}
